import React from "react";

export const ActivityType = props => {
  const { activityType } = props;

  return (
    <div>
      <span className='title'>Activity Type:</span>
      &nbsp;
      <span>
        {activityType.name}&nbsp;
        <span
          className='activity-type-preview'
          style={{ backgroundColor: activityType.color }}
        />
      </span>
    </div>
  )}
